const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d85f6a18ddd21058157c0d0809c6ce5296465920"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["apply-frontend@adway"]={id:"d85f6a18ddd21058157c0d0809c6ce5296465920"};
      